import React from 'react'
import { Accordion, Button, Card, Modal, Table } from 'react-bootstrap'
import API from './Components/Global_API'
import Router from './Router';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import TimePicker from 'react-time-picker';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"
import moment from 'moment';
import NoInternet from './Components/NoInternet';

const styles = {
    label: {
        fontWeight: '600',
        fontSize: 18
    }
}

const mark = [
    {event_date:'04-12-2020'},
    {event_date:'03-01-2021'},
    {event_date:'05-03-2021'}
]

const regex = /\uD83C\uDFF4(?:\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74)\uDB40\uDC7F|\u200D\u2620\uFE0F)|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC68(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3]))|\uD83D\uDC69\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\uD83D\uDC68(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|(?:(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)\uFE0F|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDD6-\uDDDD])(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\u200D[\u2640\u2642])|\uD83D\uDC69\u200D[\u2695\u2696\u2708])\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC68(?:\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDB5\uDDB6\uDDD1-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDEEB\uDEEC\uDEF4-\uDEF9]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD70\uDD73-\uDD76\uDD7A\uDD7C-\uDDA2\uDDB0-\uDDB9\uDDC0-\uDDC2\uDDD0-\uDDFF])|(?:[#*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEF9]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD70\uDD73-\uDD76\uDD7A\uDD7C-\uDDA2\uDDB0-\uDDB9\uDDC0-\uDDC2\uDDD0-\uDDFF])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC69\uDC6E\uDC70-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD26\uDD30-\uDD39\uDD3D\uDD3E\uDDB5\uDDB6\uDDB8\uDDB9\uDDD1-\uDDDD])/g

export default class AdminCalendar extends React.Component {
    constructor() {
        super();
        this.state = {
            date: new Date(),
            current_date: new Date(),
            title: '',
            day: '',
            description: '',
            location: '',
            notificationpopup: false,
            evevtpopup: false,
            time: '',
            event_list: [],
            not_found_msg: '',
            notificationDate: new Date(),
            event_id: '',
            user_group: '',
            course_type_id: '',
            course_type_data: [],
            error_notification_dateValidation: true,
            error_timeValidation: true,
            all_events: []
        }

        let loginUser = localStorage.getItem("loginUser")
        if (loginUser == null) {
            window.location.href = '/';
        }
    }

    componentDidMount() {
        
        fetch(API + 'get_all_data.php').then((response) => response.json()).then((responseJsonFromServer) => {

            if (responseJsonFromServer.result === "success") {
                this.setState({
                    course_type_data: responseJsonFromServer.course_type_data
                })
            } else {
                var x = document.getElementById("snackbar");
                x.className = "show";
                setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000);
                x.innerHTML = responseJsonFromServer.msg;
            }

        }).catch((error) => {
            if (error.message == 'Failed to fetch') {
                this.setState({ networkError: true })
            }
        });

        this.allEvents();
    }

    allEvents(){
        fetch(API + 'display_all_events.php').then((response) => response.json()).then((responseJsonFromServer) => {

            if (responseJsonFromServer.result === "success") {
                this.setState({
                    all_events: responseJsonFromServer.event_data
                })
            }

        }).catch((error) => {
            if (error.message == 'Failed to fetch') {
                this.setState({ networkError: true })
            }
        });
    }

    handleUserGroup = (e) => {
        this.setState({ user_group: e.target.value })

        if (e.target.value.length > 2) {
            document.getElementsByClassName('error_user_group')[0].innerHTML = "";
            document.getElementsByClassName('error_user_group')[0].style.display = 'none';
            e.target.classList.remove('error');
        }
        if (e.target.value == 'assessors' || e.target.value == 'all_users') {
            this.setState({ course_type_id: '' })
        }
    }

    handlCourseType = (e) => {
        this.setState({ course_type_id: e.target.value })
    }

    handleCloseNotification = () => {
        this.setState({ notificationpopup: false })
    }

    handleNotificationDate = (e) => {
        this.setState({
            notificationDate: e
        })
        if (e === null || e === '') {
            this.setState({ error_notification_dateValidation: false })
        } else {
            this.setState({ error_notification_dateValidation: true })
        }
    }

    handleOpenNotification = date => {

        this.setState({ date, notificationpopup: true })

        let event = JSON.stringify({
            event_date: date.toLocaleDateString("en-US")
        })

        fetch(API + 'display_event_list.php',
            {
                method: 'POST',
                body: event
            }).then((response) => response.json()).then((responseJsonFromServer) => {

                if (responseJsonFromServer.result === 'success') {
                    this.setState({ event_list: responseJsonFromServer.cpd_data })

                } else {
                    this.setState({ event_list: [], not_found_msg: responseJsonFromServer.msg })
                }
            }).catch((error) => {
                console.log(error.message);
            });
    }

    onClickMoveEdit = (item) => {
        this.setState({ evevtpopup: true, notificationpopup: false })
        this.setState({
            event_id: item.event_id,
            title: item.title,
            location: item.location,
            time: item.event_time,
            description: item.description,
            notificationDate: moment(item.noti_send_date).toDate(),
            course_type_id: item.course_type_id,
            user_group: item.user_group
        })

    }

    handleCreateEvent = () => {
        let errorcount = 0;
        if (this.state.title.trim().length < 2) {
            if (this.state.title.trim().length === 0) {
                document.getElementsByClassName('error_title')[0].innerHTML = 'Title is required.';
            }
            document.getElementsByClassName('error_title')[0].style.display = 'block';
            document.getElementById('title').classList.add('error');
            errorcount++;
        } if (this.state.location.trim().length < 2) {
            if (this.state.location.trim().length === 0) {
                document.getElementsByClassName('error_location')[0].innerHTML = 'Location is required.';
            }
            document.getElementsByClassName('error_location')[0].style.display = 'block';
            document.getElementById('location').classList.add('error');
            errorcount++;
        } if (this.state.notificationDate === '' || this.state.notificationDate === null) {
            this.setState({ error_notification_dateValidation: false })
            errorcount++;
        } if (this.state.time === '' || this.state.time === null) {
            this.setState({ error_timeValidation: false })
            errorcount++;
        } if (this.state.user_group === '') {
            if (this.state.user_group.trim().length === 0) {
                document.getElementsByClassName('error_user_group')[0].innerHTML = 'User group is required.';
            }
            document.getElementsByClassName('error_user_group')[0].style.display = 'block';
            document.getElementById('user_group').classList.add('error');
            errorcount++;
        } if (errorcount === 0) {

            let flag = 'create';
            let event_id = '';
            if (this.state.event_id != '') {
                flag = 'edit';
                event_id = this.state.event_id
            }

            let event = JSON.stringify({
                title: this.state.title,
                event_id: event_id,
                flag: flag,
                location: this.state.location,
                description: this.state.description,
                noti_send_date: this.state.notificationDate.toLocaleDateString("en-US"),
                event_date: this.state.date.toLocaleDateString("en-US"),
                event_time: this.state.time,
                course_type_id: this.state.course_type_id,
                user_group: this.state.user_group
            })

            fetch(API + 'add_edit_event.php', {
                method: 'POST',
                body: event
            }).then((response) => response.json()).then((responseJsonFromServer) => {

                if (responseJsonFromServer.result == "success") {
                    this.setState({
                        course_type_id: '',
                        user_group: '',
                        error_timeValidation: true,
                        error_notification_dateValidation: true,
                        evevtpopup: false,
                        notificationpopup: true,
                    })
                    this.handleOpenNotification(this.state.date)

                }
            })
        }


    }

    handleTitle = (e) => {
        this.setState({ title: e.target.value })

        if (e.target.value.trim().length === 0) {
            document.getElementsByClassName('error_title')[0].innerHTML = 'Title is required.';
            document.getElementsByClassName('error_title')[0].style.display = 'block';
            e.target.classList.add('error');
        } else if (e.target.value.trim().length < 2 || e.target.value.trim().length > 50) {
            document.getElementsByClassName('error_title')[0].innerHTML = 'Title must be between 2 to 50 character.';
            document.getElementsByClassName('error_title')[0].style.display = 'block';
            e.target.classList.add('error');
        } else if (e.target.value.trim().match(regex)) {
            document.getElementsByClassName('error_title')[0].innerHTML = 'Please Enter valid Title.';
            document.getElementsByClassName('error_title')[0].style.display = 'block';
            e.target.classList.add('error');
        } else {
            document.getElementsByClassName('error_title')[0].innerHTML = "";
            document.getElementsByClassName('error_title')[0].style.display = 'none';
            e.target.classList.remove('error');
        }
    }

    handleLocation = (e) => {
        this.setState({ location: e.target.value })
        if (e.target.value.trim().length === 0) {
            document.getElementsByClassName('error_location')[0].innerHTML = 'Location is required.';
            document.getElementsByClassName('error_location')[0].style.display = 'block';
            e.target.classList.add('error');
        } else if (e.target.value.trim().length < 2 || e.target.value.trim().length > 150) {
            document.getElementsByClassName('error_location')[0].innerHTML = 'Location must be between 2 to 150 character.';
            document.getElementsByClassName('error_location')[0].style.display = 'block';
            e.target.classList.add('error');
        } else if (e.target.value.trim().match(regex)) {
            document.getElementsByClassName('error_location')[0].innerHTML = 'Please Enter valid Location.';
            document.getElementsByClassName('error_location')[0].style.display = 'block';
            e.target.classList.add('error');
        } else {
            document.getElementsByClassName('error_location')[0].innerHTML = "";
            document.getElementsByClassName('error_location')[0].style.display = 'none';
            e.target.classList.remove('error');
        }
    }

    handleDescription = (e) => {
        this.setState({ description: e.target.value })
    }

    handleCreateEventPopupClose = () => {
        this.setState({
            evevtpopup: false,
            notificationpopup: true,
            course_type_id: '',
            user_group: '',
            error_timeValidation: true,
            error_notification_dateValidation: true
        })
    }

    handleCreateEventPopupOpen = () => {
        this.setState({
            evevtpopup: true,
            notificationpopup: false,
            event_id: '',
            title: '',
            description: '',
            notificationDate: new Date(),
            time: '',
            location: ''
        })
    }

    onChangeTime = (time) => {
        this.setState({ time })
        if (time === null || time === '') {
            this.setState({ error_timeValidation: false })
        } else {
            this.setState({ error_timeValidation: true })
        }

    }


    render() {

        if (this.state.networkError) {
            return <NoInternet />
        } else {
            return (
                <div>
                    <Router />
                    <div style={{ backgroundColor: 'rgb(235, 236, 237)', minHeight: '100vh', overflowY: 'auto', overflowX: 'hidden' }}>
                        <div className="block-v-md" style={{ backgroundColor: '#ffff', paddingLeft: 20, paddingTop: 80, paddingRight: 20, paddingBottom: 20 }}>

                            <div>
                                <div className="row" style={{ marginTop: -10, marginBottom: -10 }}>
                                    <Accordion style={{ width: '100%' }} defaultActiveKey="0">
                                        <div className="row">
                                            <div className="col-md-4 col-sm-4 block-v-sm"></div>
                                            <div className="col-md-4 col-sm-4 text-center block-v-sm" style={{ paddingTop: 5, paddingRight: 30 }}>
                                                <Accordion.Toggle as={Button} style={{ backgroundColor: '#ebeced', marginRight: 10, fontSize: 18, cursor: 'default' }} variant="default" eventKey="0">
                                                    <span style={{ fontWeight: '700' }}>Add event</span>
                                                </Accordion.Toggle>
                                            </div>
                                        </div>
                                    </Accordion>
                                </div>
                            </div>
                        </div>
                        <div className="body-container" style={{ padding: 40 }}>
                            <Calendar
                                onChange={this.handleOpenNotification}
                                value={this.state.date}
                                tileClassName={({ date, view }) => {
                                    if(this.state.all_events.find(x=>x.event_date===moment(date).format("DD-MM-YYYY"))){
                                     return  'highlight'
                                    }
                                  }}
                            />
                            <Modal show={this.state.notificationpopup} size="xl" onHide={this.handleCloseNotification} >
                                <Modal.Header closeButton style={{ border: '0px' }}>
                                </Modal.Header>
                                <Modal.Body style={{ height: 700, overflow: 'auto' }}>
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-lg-9 col-sm-8 col-md-8">
                                                <h4 style={{ marginTop: 5 }}>Events</h4>
                                            </div>
                                            <div className="col-lg-3 col-sm-4 col-md-4">
                                                <Button
                                                    disabled={this.state.date <= this.state.current_date}
                                                    style={{ cursor: this.state.date <= this.state.current_date ? 'no-drop' : 'pointer' }}
                                                    onClick={this.handleCreateEventPopupOpen}
                                                >
                                                    Add new event
                                            </Button>
                                            </div>
                                        </div>
                                        <div style={{ paddingTop: 40 }}>
                                            {this.state.event_list.length == 0 ? <div className="text-center">
                                                <h3>{this.state.not_found_msg}</h3>
                                            </div> :
                                                <Table style={{ border: 'hidden' }} responsive hover>
                                                    <thead>
                                                        <tr style={{ border: 'hidden' }}>
                                                            <th width={'5%'}></th>
                                                            <th width={'20%'}>Title</th>
                                                            <th width={'15%'}>Event time</th>
                                                            <th width={'30%'}>Location</th>
                                                            <th width={'30%'}>Description</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.event_list.map((item, i) =>
                                                            <tr style={{ border: 'hidden', cursor: 'pointer' }} onClick={() => this.onClickMoveEdit(item)}>
                                                                <td width={'5%'}>{i + 1}.</td>
                                                                <td width={'20%'}>{item.title}</td>
                                                                <td width={'15%'}>{item.event_time}</td>
                                                                <td width={'30%'}>{item.location}</td>
                                                                <td width={'30%'}>{item.description}</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </Table>}
                                        </div>
                                    </div>
                                </Modal.Body>
                            </Modal>

                            <Modal show={this.state.evevtpopup} size="xl" onHide={() => { this.setState({ evevtpopup: false, course_type_id: '', user_group: '', error_timeValidation: true, error_notification_dateValidation: true }) }} >
                                <Modal.Header closeButton style={{ border: '0px' }}>
                                </Modal.Header>
                                <Modal.Body style={{ minHeight: 700 }}>
                                    <div className="col-12">
                                        <div className="mb-4">
                                            <input className="form-control" id="title" placeholder="Add title*" value={this.state.title} onChange={this.handleTitle} style={{ fontSize: 20, borderBottom: '1px solid #999', borderLeft: 0, borderRight: 0, borderTop: 0 }} />
                                            <label className="input-error error_title text-left"></label>
                                        </div>
                                        <div className="mb-4">
                                            <input className="form-control" id="location" placeholder="Location*" value={this.state.location} onChange={this.handleLocation} />
                                            <label className="input-error error_location text-left"></label>
                                        </div>
                                        <div className="col-12 row" style={{ lineHeight: 3 }}>
                                            <span style={{ padding: '5px 10px 0 0' }}>Send notification on the*</span>
                                            <div className="col-2 p-0">
                                                <DatePicker
                                                    className={!this.state.error_notification_dateValidation ? "error form-control" : "form-control"}
                                                    minDate={new Date()}
                                                    maxDate={this.state.date}
                                                    selected={this.state.notificationDate}
                                                    onChange={this.handleNotificationDate}
                                                    showTimeSelect={false}
                                                    dateFormat="dd/MM/yyyy"
                                                    locale={false}
                                                    showTimeSelect={false}
                                                    showTimeInput={false}
                                                />
                                            </div>
                                            <span style={{ padding: '5px 10px' }}>. Event time is*</span>
                                            <TimePicker
                                                // className="form-control mb-4"
                                                className={!this.state.error_timeValidation ? "error form-control mb-4" : "form-control mb-4"}
                                                onChange={this.onChangeTime}
                                                value={this.state.time}
                                                format="h:m a"
                                            />
                                        </div>
                                        <div className="mb-4">
                                            <textarea className="form-control" id="description" value={this.state.description} onChange={this.handleDescription} placeholder="Add description" rows="6"></textarea>
                                        </div>
                                        <div className="row p-0 m-0">
                                            <div className="col-lg-6 col-md-6 col-sm-12 pl-0">
                                                <h6 style={styles.label}>User group*</h6>
                                                <select className="form-control" id="user_group" value={this.state.user_group} onChange={this.handleUserGroup}>
                                                    <option value='' hidden>select user group</option>
                                                    <option value="learners">Learners</option>
                                                    <option value="assessors">Assessors</option>
                                                    <option value="all_users">All users</option>
                                                </select>
                                                <label className="input-error error_user_group text-left"></label>
                                            </div>
                                            <div className="col-lg-6 col-md-6 col-sm-12 pr-0" style={{ visibility: this.state.user_group == 'learners' ? '' : 'hidden' }}>
                                                <h6 style={styles.label}>Package type</h6>
                                                <select className="form-control" value={this.state.course_type_id} onChange={this.handlCourseType}>
                                                    <option hidden>select package type</option>
                                                    {this.state.course_type_data.map((item, i) =>
                                                        <option value={item.course_type_id}>{item.course_type}</option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="row p-0">
                                            <div className="col-2"></div>
                                            <div className="col-lg-4 col-md-4 col-sm-12 pt-3" >
                                                <Button variant="primary" block onClick={this.handleCreateEvent}>Save</Button>
                                            </div>
                                            <div className="col-lg-4 col-md-4 col-sm-12 pt-3" >
                                                <Button variant="primary" block onClick={this.handleCreateEventPopupClose}>Cancel</Button>
                                            </div>
                                        </div>
                                    </div>
                                </Modal.Body>
                            </Modal>
                        </div>
                    </div>
                </div>
            )
        }
    }
}